<template>
    <div>
        <div v-if="loading" class="pt-5">
            <Loader class="mt-5"/>
        </div>
        <CampPreview
            v-else
            :previewData="dataFromFirebase"
        />
    </div>
</template>

<script>
    import moment from 'moment'
    import { DEFAULT_CAMPAIGN_COLLECTION } from '../../firebase.js'
    import { getData, getDataByDocId } from "../../firebaseCRUD";
    import CampPreview from '@/components/PreviewCampaign'
    import { Loader } from '../Icons'
    export default {
        name: "PreviewCampaign",
        components: {
            CampPreview,
            Loader
        },
        props: {
            model: String
        },
        computed: {
            collection: function () {
                if (this.model) return this.model;
                if (this.$route.query.model) return this.$route.query.model;
                if (this.$route.name === 'Campaign Page') return 'campaigns'

                return DEFAULT_CAMPAIGN_COLLECTION
            }
        },
        data() {
            return {
                loading: false,
                dataFromFirebase: {}
            }
        },
        watch: {
            '$route.params.campaignID': 'getDataFromFirebase',
            '$route.query.id': 'getDataFromFirebase'
        },
        mounted() {
            this.getDataFromFirebase()
        },
        methods: {
            async getDataFromFirebase() {
                this.loading = true
                if (!this.$route.params.campaignID && !this.$route.query.id) {
                    this.$router.push('/').catch(() => {})
                }

                try {

                    const campaignId = this.$route.params.campaignID || this.$route.query.id
                    const campaignSnapshot = await getDataByDocId({
                        collection: this.collection,
                        id: campaignId
                    });

                    const spotsSnapshot = await getData( 'updates', {
                        field: 'cid',
                        condition: '==',
                        value: campaignId
                    });

                    const data = {
                        ...campaignSnapshot.data(),
                        id: campaignSnapshot.id
                    }

                    data.scheduler = spotsSnapshot.docs
                        .filter(
                            (spot) => moment().isBefore(
                                // + 86400 to show the current day
                                moment.unix(spot.data().date.seconds + 86400)
                            )
                        )
                        .map(
                            date => {
                                const data = {...date.data()}
                                data.date = new Date(data.date.seconds * 1000)
                                data.busyIndexes = new Set()
                                data.spots.forEach(
                                    (spot, index) => {
                                        if (spot) {
                                            data.busyIndexes.add(index)
                                        }
                                    }
                                )
                                return data
                            }
                        )
                    data.scheduler.sort(
                        (a, b) => a.date.getTime() - b.date.getTime()
                    );
                    this.dataFromFirebase = {
                        ...data,
                        daystogo: data.days_to_go || data.daystogo || 0
                    };
                    if(data.category){
                        this.$store.commit('SET_RELATED_CATEGORY', data.category.toLowerCase());
                    }
                } catch (e) {
                    console.log(e);
                } finally {
                    this.loading = false
                }
            }
        },
    }
</script>